<template>
  <v-card flat class="pa-4" style="background: transparent;">
    <v-row no-gutters class="pa-6">
      <v-col cols="12" md="6">
        <v-text-field
          class="ma-2"
          id="TabChangePassword_password"
          :label="$tc('new_password')"
          :hint="$tc('new_password_hint')"
          type="password"
          autocomplete="new-password"
          v-model="password"
          counter
          :error-messages="passwordErrors"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
        />
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          id="TabChangePassword_repeatPassword"
          class="ma-2"
          :label="$tc('repeat_password')"
          type="password"
          autocomplete="new-password"
          v-model="repeatPassword"
          counter
          :error-messages="repeatPasswordErrors"
          @input="$v.repeatPassword.$touch()"
          @blur="$v.repeatPassword.$touch()"
        />
      </v-col>

      <v-col cols="12">
        <v-btn
          id="TabChangePassword_save"
          class="ma-2"
          color="blue"
          :disabled="$v.$invalid"
          :dark="!$v.$invalid"
          @click="changePwd"
        >
          {{ $t('save') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import {
  required,
  sameAs,
  minLength,
  maxLength
} from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      password: null,
      repeatPassword: null
    }
  },
  computed: {
    passwordPolicy () {
      return this.$store.state.secPolicy
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.minLength &&
        errors.push(
          this.$t('$validation.min_length', {
            num: this.passwordPolicy.min_len
          })
        )
      !this.$v.password.maxLength &&
        errors.push(
          this.$t('$validation.max_length', {
            num: this.$v.password.$params.maxLength.max
          })
        )
      !this.$v.password.required && errors.push(this.$t('$validation.required'))
      !this.$v.password.minUpperCase &&
        errors.push(
          this.$t('$validation.min_upper', {
            num: this.passwordPolicy.min_upper
          })
        )
      !this.$v.password.minLowerCase &&
        errors.push(
          this.$t('$validation.min_lower', {
            num: this.passwordPolicy.min_lower
          })
        )
      !this.$v.password.minSpecialChars &&
        errors.push(
          this.$t('$validation.min_special', {
            num: this.passwordPolicy.min_special
          })
        )
      return errors
    },
    repeatPasswordErrors () {
      const errors = []
      if (!this.$v.repeatPassword.$dirty) return errors
      !this.$v.repeatPassword.sameAs &&
        errors.push(this.$t('$validation.same_as'))
      !this.$v.repeatPassword.required &&
        errors.push(this.$t('$validation.required'))
      return errors
    }
  },
  validations () {
    const minUpperCase = value => {
      if (!value) return true
      return (
        (value.match(/[A-Z]/g) || []).length >= this.passwordPolicy.min_upper
      )
    }

    const minLowerCase = value => {
      if (!value) return true
      return (
        (value.match(/[a-z]/g) || []).length >= this.passwordPolicy.min_lower
      )
    }

    const minSpecialChars = value => {
      if (!value) return true
      return (
        (value.match(/\W|_/g) || []).length >= this.passwordPolicy.min_special
      )
    }
    return {
      password: {
        required,
        minLength: minLength(this.passwordPolicy.min_len),
        maxLength: maxLength(16),
        minUpperCase,
        minLowerCase,
        minSpecialChars
      },
      repeatPassword: {
        required,
        sameAs: sameAs('password')
      }
    }
  },
  methods: {
    changePwd () {
      this.$store.commit('auth/SET_PASSWORD', this.password)
      this.$store
        .dispatch('auth/doChangePassword')
        .then(() => {
          this.$notify.success({})
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    }
  }
}
</script>
